// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sneasler: PokeData = {
  "id": 903,
  "name": "sneasler",
  "height": 13,
  "weight": 430,
  "base_experience": 102,
  "types": [
    PokeType.FIGHTING,
    PokeType.POISON
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "leer",
    "agility",
    "quick-attack",
    "screech",
    "swift",
    "slash",
    "metal-claw",
    "rock-smash",
    "taunt",
    "brick-break",
    "close-combat",
    "fling",
    "poison-jab",
    "hone-claws",
    "dire-claw"
  ],
  "moves": [
    "scratch",
    "leer",
    "quick-attack",
    "metal-claw",
    "rock-smash",
    "close-combat",
    "poison-jab",
    "toxic-spikes",
    "sludge-bomb",
    "vacuum-wave",
    "purify",
    "mortal-gas",
    "stun-spore"
  ],
  "evolution_chain": {
    "id": 109,
    "item": null,
    "species": [
      {
        "name": "sneasel",
        "order": 245,
        "types": [
          PokeType.DARK,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "weavile",
        "order": 246,
        "types": [
          PokeType.DARK,
          PokeType.ICE
        ],
        "evolves_from_species_id": 215,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "sneasler",
        "order": 903,
        "types": [
          PokeType.FIGHTING,
          PokeType.POISON
        ],
        "evolves_from_species_id": 215,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 92,
    "speed": 148,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 135,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
